module.exports = __webpack_public_path__ + "media/images/ac_templates/201/broht-f2f3d2147435edfc3c03488a0d7ef102.jpg";